import {
  FETCH_DISTRIBUTORS_SUCCESS_ACTION,
  FETCH_DETAILVIEW_SUCCESS_ACTION,
  FETCH_DISTRIBUTORSTATUS_SUCCESS_ACTION
} from "./action";

const initialState = {
  processing: false,
  error: false
};

export default function(state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_DISTRIBUTORS_SUCCESS_ACTION:
      // console.log(action.payload);
      return {
        ...state,
        DistributorsList: action.payload.rows,
        DistributorsCount: action.payload.count
      };

    case FETCH_DETAILVIEW_SUCCESS_ACTION:
      return {
        ...state,
        distributorDetail: action.payload
      };

    case FETCH_DISTRIBUTORSTATUS_SUCCESS_ACTION:
      return {
        ...state,
        distributorStatus: action.payload
      };

    default:
      return {
        ...state
      };
  }
}
